var map = {
	"./hero-image.png": 6592,
	"./home-vector-design.png": 7587,
	"./logo_bg.webp": 3441,
	"./quizmegpt-logo.png": 9759,
	"./quizmegpt-logo2.png": 238,
	"./results-ill.png": 331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;